/*
  AnayaLisa — product page features
  1. Size guide dialog (snippets/sg-size-guide.liquid)
  2. "Achetez plus, économisez" quantity offers (snippets/sg-offers.liquid)
  3. "Composer mon lot" mixed-product selector (sections/sg-bundle-*.liquid)

  Pricing authority = native Shopify automatic discounts. Everything here is a preview;
  the cart and checkout totals computed by Shopify always win.
*/
(function () {
  'use strict';
  if (window.SGFeatures) return;
  window.SGFeatures = { version: '1.0.0' };

  /* ---------------------------------------------------------------- utils */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function fmt(str, vars) {
    return String(str || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) {
      return vars && vars[k] !== undefined ? vars[k] : '';
    });
  }

  function money(cents, format) {
    try {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, format || (theme.settings && theme.settings.moneyFormat));
      }
    } catch (e) { /* fall through */ }
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        var v = attrs[k];
        if (v === null || v === undefined || v === false) return;
        if (k === 'text') node.textContent = v;
        else if (k === 'html') node.innerHTML = v;
        else if (k === 'class') node.className = v;
        else if (k.indexOf('on') === 0 && typeof v === 'function') node.addEventListener(k.slice(2), v);
        else node.setAttribute(k, v === true ? '' : v);
      });
    }
    (children || []).forEach(function (c) {
      if (c === null || c === undefined || c === false) return;
      node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return node;
  }

  function readJSON(scope, selector) {
    var node = scope.querySelector(selector);
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  /* Integer minor-unit arithmetic. Shopify truncates percentage discounts to the cent
     (verified on this store: 15 % of 149,85 € = 22,47 €), so we floor too.
     Shopify's cart/checkout allocation remains authoritative. */
  function discountFor(subtotal, pct) { return Math.floor((subtotal * pct) / 100); }

  /* ---------------------------------------------------------------- dialogs */
  var openDialogs = 0;
  function lockScroll() {
    openDialogs += 1;
    if (openDialogs === 1) {
      document.documentElement.classList.add('sg-scroll-lock');
    }
  }
  function unlockScroll() {
    openDialogs = Math.max(0, openDialogs - 1);
    if (openDialogs === 0) document.documentElement.classList.remove('sg-scroll-lock');
  }

  function prepareDialog(dlg) {
    if (dlg._sgReady) return;
    dlg._sgReady = true;
    dlg.addEventListener('close', function () {
      unlockScroll();
      var opener = dlg._sgOpener;
      dlg._sgOpener = null;
      if (opener && document.contains(opener) && typeof opener.focus === 'function') {
        try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); }
      }
    });
    // click on the backdrop closes
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) dlg.close();
    });
    dlg.addEventListener('click', function (e) {
      if (e.target.closest('[data-sg-close]')) dlg.close();
    });
  }

  function openDialog(dlg, opener) {
    if (!dlg) return;
    prepareDialog(dlg);
    if (dlg.open) return;
    dlg._sgOpener = opener || document.activeElement;
    if (typeof dlg.showModal === 'function') {
      dlg.showModal();
    } else {
      dlg.setAttribute('open', '');
    }
    lockScroll();
    var focusTarget = dlg.querySelector('[data-sg-autofocus]') || dlg.querySelector('[data-sg-close],[data-sg-bundle-close]');
    if (focusTarget) focusTarget.focus();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-sg-open]');
    if (!trigger) return;
    e.preventDefault();
    openDialog(document.getElementById(trigger.getAttribute('data-sg-open')), trigger);
  });

  /* ---------------------------------------------------------------- cart state */
  var Cart = {
    data: null,
    listeners: [],
    inflight: null,
    fetch: function () {
      if (Cart.inflight) return Cart.inflight;
      Cart.inflight = fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          Cart.data = data;
          Cart.inflight = null;
          Cart.listeners.forEach(function (fn) { try { fn(data); } catch (e) {} });
          return data;
        })
        .catch(function (err) { Cart.inflight = null; throw err; });
      return Cart.inflight;
    },
    count: function () {
      if (!Cart.data) return 0;
      // Gift cards are never discounted by Shopify; there are none in the catalogue today,
      // but keep them out of the count shown to shoppers.
      return Cart.data.items.reduce(function (n, item) { return n + (item.gift_card ? 0 : item.quantity); }, 0);
    },
    qtyByVariant: function (data) {
      var map = {};
      (data || Cart.data || { items: [] }).items.forEach(function (item) {
        map[item.variant_id] = (map[item.variant_id] || 0) + item.quantity;
      });
      return map;
    },
    onChange: function (fn) { Cart.listeners.push(fn); }
  };

  var refreshTimer = null;
  function scheduleCartRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { Cart.fetch().catch(function () {}); }, 400);
  }
  // Notice cart mutations made by the theme, UpCart or anything else, without patching fetch.
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (/\/cart\/(add|change|update|clear)(\.js)?/.test(entry.name)) scheduleCartRefresh();
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) { /* ignore */ }
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') scheduleCartRefresh();
  });
  document.addEventListener('cart:updated', scheduleCartRefresh);

  /* open=false after a partial failure: refresh the cart UI but keep the error message in view. */
  function refreshCartUI(open) {
    // UpCart (cart drawer app) when present, otherwise the theme's own drawer.
    if (typeof window.upcartRefreshCart === 'function') {
      try { window.upcartRefreshCart(); } catch (e) {}
      if (open && typeof window.upcartOpenCart === 'function') {
        try { window.upcartOpenCart(); } catch (e) {}
      } else if (!open && typeof window.upcartCloseCart === 'function') {
        // UpCart may auto-open on any add.js response; close it so the shopper sees what failed.
        setTimeout(function () { try { window.upcartCloseCart(); } catch (e) {} }, 600);
      }
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:build'));
    if (open) document.dispatchEvent(new CustomEvent('cart:open'));
  }

  /*
    Add several existing variants in ONE request. On any failure, re-read the cart and work out
    exactly which units made it in, so a retry never adds them twice.
    units: [{ key, variantId, label }]
    resolves { ok, addedKeys: [], failedUnits: [], message }
  */
  function addUnits(units) {
    var before;
    return Cart.fetch()
      .catch(function () { return null; })
      .then(function (data) {
        before = Cart.qtyByVariant(data || { items: [] });
        var grouped = {};
        var order = [];
        units.forEach(function (u) {
          if (!grouped[u.variantId]) { grouped[u.variantId] = 0; order.push(u.variantId); }
          grouped[u.variantId] += 1;
        });
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: order.map(function (id) { return { id: Number(id), quantity: grouped[id] }; }) })
        });
      })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (body) { return { res: res, body: body }; });
      }, function () { return { res: null, body: {} }; })
      .then(function (r) {
        var ok = r.res && r.res.ok;
        return Cart.fetch().catch(function () { return null; }).then(function (after) {
          var afterMap = Cart.qtyByVariant(after || { items: [] });
          var delta = {};
          Object.keys(afterMap).forEach(function (id) { delta[id] = afterMap[id] - (before[id] || 0); });
          var addedKeys = [];
          var failedUnits = [];
          units.forEach(function (u) {
            if ((delta[u.variantId] || 0) > 0) { delta[u.variantId] -= 1; addedKeys.push(u.key); }
            else failedUnits.push(u);
          });
          return {
            ok: ok && failedUnits.length === 0,
            addedKeys: addedKeys,
            failedUnits: failedUnits,
            message: (r.body && (r.body.description || r.body.message)) || ''
          };
        });
      });
  }

  /* ---------------------------------------------------------------- variant row */
  /* A row of <select>s for one unit of a product, only offering genuine, available combinations. */
  function VariantPicker(product, opts) {
    this.product = product;
    this.opts = opts || {};
    this.optionNames = (product.options || []).filter(function (n) { return n !== 'Title'; });
    this.single = product.variants.length === 1 && this.optionNames.length === 0;
    this.values = this.optionNames.map(function (_, i) {
      var seen = [];
      product.variants.forEach(function (v) { if (seen.indexOf(v.options[i]) === -1) seen.push(v.options[i]); });
      return seen;
    });
    var start = this.findById(opts.variantId) || product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    this.selected = start.options.slice();
    this.node = el('div', { class: 'sg-picker' });
    this.render();
  }
  VariantPicker.prototype.findById = function (id) {
    if (!id) return null;
    return this.product.variants.filter(function (v) { return String(v.id) === String(id); })[0] || null;
  };
  VariantPicker.prototype.current = function () {
    var sel = this.selected;
    return this.product.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    })[0] || null;
  };
  /* Hierarchical availability: option 1 on its own, option 2 within option 1, etc. */
  VariantPicker.prototype.isPossible = function (optIndex, value) {
    var sel = this.selected;
    return this.product.variants.some(function (v) {
      if (!v.available || v.options[optIndex] !== value) return false;
      for (var i = 0; i < optIndex; i++) { if (v.options[i] !== sel[i]) return false; }
      return true;
    });
  };
  VariantPicker.prototype.setVariant = function (id) {
    var v = this.findById(id);
    if (!v) return;
    this.selected = v.options.slice();
    this.render();
  };
  VariantPicker.prototype.render = function () {
    var self = this;
    this.node.innerHTML = '';
    if (this.single) return;
    this.optionNames.forEach(function (name, i) {
      var id = (self.opts.idPrefix || 'sg') + '-opt-' + i;
      var select = el('select', { id: id, class: 'sg-picker__select' });
      self.values[i].forEach(function (value) {
        var possible = self.isPossible(i, value);
        var option = el('option', { value: value, text: possible ? value : value + ' — ' + (self.opts.strings.unavailable || '') });
        if (!possible) option.disabled = true;
        if (value === self.selected[i]) option.selected = true;
        select.appendChild(option);
      });
      select.addEventListener('change', function () {
        self.selected[i] = select.value;
        self.render();
        if (self.opts.onChange) self.opts.onChange(self.current(), true);
        var again = self.node.querySelector('#' + CSS.escape(id));
        if (again) again.focus();
      });
      self.node.appendChild(el('div', { class: 'sg-picker__field' }, [
        el('label', { for: id, class: 'sg-picker__label', text: (self.opts.labelPrefix ? self.opts.labelPrefix + ' — ' : '') + name }),
        select
      ]));
    });
    var v = this.current();
    if (!v || !v.available) {
      this.node.appendChild(el('p', { class: 'sg-picker__warning', role: 'alert', text: self.opts.strings.unavailable_combo }));
    }
  };

  /* ---------------------------------------------------------------- offers */
  function Offers(container) {
    this.c = container;
    this.product = readJSON(container, '[data-sg-product]');
    this.s = readJSON(container, '[data-sg-strings]') || {};
    this.tiers = JSON.parse(container.getAttribute('data-tiers') || '{}');
    this.moneyFormat = container.getAttribute('data-money-format');
    this.form = document.getElementById(container.getAttribute('data-form-id'));
    if (!this.product || !this.form) return;
    this.button = this.form.querySelector('[data-add-to-cart]');
    this.buttonText = this.form.querySelector('[data-add-to-cart-text]');
    this.rowsNode = container.querySelector('[data-sg-rows]');
    this.summary = container.querySelector('[data-sg-summary]');
    this.errorNode = container.querySelector('[data-sg-error]');
    this.moreNode = container.querySelector('[data-sg-more]');
    this.qty = 1;
    this.rows = [];
    this.busy = false;
    this.bind();
    this.syncMain();
    this.update();
    var self = this;
    Cart.onChange(function () { self.update(); });
    Cart.fetch().catch(function () {});
    if (container.querySelector('[data-sg-bundle]')) this.bundle = new Bundle(this);
  }

  Offers.prototype.pctFor = function (count) {
    if (count >= 4) return Number(this.tiers['4'] || 0);
    if (count === 3) return Number(this.tiers['3'] || 0);
    if (count === 2) return Number(this.tiers['2'] || 0);
    return 0;
  };
  Offers.prototype.nextTier = function (count) {
    var steps = [2, 3, 4];
    for (var i = 0; i < steps.length; i++) {
      if (count < steps[i]) return { at: steps[i], pct: this.pctFor(steps[i]) };
    }
    return null;
  };
  Offers.prototype.variant = function (id) {
    return this.product.variants.filter(function (v) { return String(v.id) === String(id); })[0] || null;
  };
  Offers.prototype.mainVariantId = function () {
    var select = this.form.querySelector('[name="id"]');
    return select ? select.value : this.product.variants[0].id;
  };

  Offers.prototype.bind = function () {
    var self = this;
    this.c.querySelectorAll('.sg-offer-card__input').forEach(function (input) {
      input.addEventListener('change', function () { self.setQty(Number(input.value)); });
    });
    // Main picker changed → follow it in row 1 unless the shopper changed row 1 herself.
    // The theme updates the hidden master select (and fires 'change') after it has updated the button.
    var master = this.form.querySelector('[name="id"]');
    if (master) {
      master.addEventListener('change', function () {
        self.syncMain();
        setTimeout(function () { self.applyButtonState(); }, 0);
      });
    }
    var section = this.c.closest('[data-section-type="product"]');
    if (section) {
      section.addEventListener('variantChange', function () {
        setTimeout(function () { self.applyButtonState(); }, 0);
      });
    }
    // Capture the add before the theme or any app (e.g. UpCart, which listens to the button click)
    // sees it — only when 2+ items are chosen. Window capture runs before document/element listeners.
    window.addEventListener('click', function (e) {
      if (self.qty < 2 || !self.button) return;
      var btn = e.target.closest && e.target.closest('[data-add-to-cart]');
      if (btn !== self.button) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      self.addSelection();
    }, true);
    window.addEventListener('submit', function (e) {
      if (e.target !== self.form || self.qty < 2) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      self.addSelection();
    }, true);
  };

  Offers.prototype.syncMain = function () {
    var mainId = this.mainVariantId();
    if (!this.rows.length) this.rows.push(this.makeRow(mainId));
    var first = this.rows[0];
    if (!first.userSet && String(first.variantId) !== String(mainId)) {
      first.variantId = mainId;
      first.picker.setVariant(mainId);
      this.renderRow(first, 0);
    }
    this.update();
  };

  Offers.prototype.makeRow = function (variantId) {
    var self = this;
    var row = { key: 'r' + Math.random().toString(36).slice(2), variantId: variantId, userSet: false, added: false };
    row.picker = new VariantPicker(this.product, {
      variantId: variantId,
      strings: this.s,
      idPrefix: 'sg-' + this.c.getAttribute('data-uid') + '-' + row.key,
      onChange: function (v) {
        row.userSet = true;
        row.added = false;
        row.variantId = v ? v.id : null;
        row.valid = !!(v && v.available);
        self.renderRow(row, self.rows.indexOf(row));
        self.update();
      }
    });
    var v = this.variant(variantId);
    row.valid = !!(v && v.available);
    return row;
  };

  Offers.prototype.setQty = function (n) {
    this.qty = n;
    this.c.querySelectorAll('[data-sg-card]').forEach(function (card) {
      card.classList.toggle('is-selected', Number(card.getAttribute('data-sg-card')) === n);
    });
    var mainId = this.mainVariantId();
    if (!this.rows.length) this.rows.push(this.makeRow(mainId));
    var template = this.rows[0].variantId || mainId;
    while (this.rows.length < n) this.rows.push(this.makeRow(template));
    if (this.rows.length > n) this.rows.length = n;
    this.hideError();
    this.renderRows();
    this.update();
  };

  Offers.prototype.renderRows = function () {
    var self = this;
    this.rowsNode.innerHTML = '';
    if (this.qty < 2) { this.rowsNode.hidden = true; return; }
    this.rowsNode.hidden = false;
    this.rows.forEach(function (row, i) {
      row.node = el('div', { class: 'sg-row', 'data-row': i });
      self.rowsNode.appendChild(row.node);
      self.renderRow(row, i);
    });
  };

  Offers.prototype.renderRow = function (row, i) {
    if (!row.node || i < 0) return;
    var v = this.variant(row.variantId);
    var img = (v && v.image) || this.product.image;
    row.node.innerHTML = '';
    row.node.classList.toggle('is-invalid', !row.valid);
    row.node.classList.toggle('is-added', !!row.added);
    row.picker.opts.labelPrefix = fmt(this.s.item_label, { number: i + 1 });
    row.picker.render();
    var head = el('div', { class: 'sg-row__head' }, [
      img ? el('img', { class: 'sg-row__img', src: img, alt: '', width: 56, height: 56, loading: 'lazy' }) : null,
      el('div', { class: 'sg-row__meta' }, [
        el('span', { class: 'sg-row__title', text: fmt(this.s.item_label, { number: i + 1 }) }),
        el('span', { class: 'sg-row__price', text: v ? money(v.price, this.moneyFormat) : '' }),
        row.added ? el('span', { class: 'sg-row__added', text: '✓ ' + this.s.added_row }) : null
      ])
    ]);
    row.node.appendChild(head);
    row.node.appendChild(row.picker.node);
  };

  Offers.prototype.priceForCount = function (n) {
    var self = this;
    var main = this.variant(this.mainVariantId());
    var mainPrice = main ? main.price : this.product.variants[0].price;
    var subtotal = 0;
    for (var i = 0; i < n; i++) {
      var row = this.rows[i];
      var v = row ? self.variant(row.variantId) : null;
      subtotal += v ? v.price : mainPrice;
    }
    var pct = this.pctFor(n);
    var discount = discountFor(subtotal, pct);
    return { subtotal: subtotal, discount: discount, total: subtotal - discount, pct: pct };
  };

  Offers.prototype.update = function () {
    var self = this;
    // Card prices: each card reflects the selected items' current selling prices (never compare-at).
    this.c.querySelectorAll('[data-sg-card]').forEach(function (card) {
      var n = Number(card.getAttribute('data-sg-card'));
      var p = self.priceForCount(n);
      var total = card.querySelector('[data-sg-card-total]');
      var compare = card.querySelector('[data-sg-card-compare]');
      if (total) total.textContent = money(p.total, self.moneyFormat);
      if (compare) compare.textContent = money(p.subtotal, self.moneyFormat);
    });
    this.moreNode.hidden = this.qty < 4;
    this.renderSummary();
    this.applyButtonState();
  };

  Offers.prototype.renderSummary = function () {
    var s = this.s;
    var parts = [];
    var n = this.qty;
    if (n >= 2) {
      var p = this.priceForCount(n);
      parts.push(el('p', { class: 'sg-summary__line sg-summary__line--strong' }, [
        fmt(s.selection_total, { count: n }) + ' : ',
        el('strong', { text: money(p.total, this.moneyFormat) }),
        p.discount > 0 ? ' ' + s.instead_of + ' ' : '',
        p.discount > 0 ? el('s', { text: money(p.subtotal, this.moneyFormat) }) : null
      ]));
    }
    var inCart = Cart.data ? Cart.count() : 0;
    if (inCart > 0) {
      var after = inCart + n;
      var pctAfter = this.pctFor(after);
      parts.push(el('p', { class: 'sg-summary__line', text: fmt(s.cart_has, { count: inCart }) + ' ' +
        (pctAfter > 0 ? fmt(s.cart_after, { count: after, percent: pctAfter }) : fmt(s.cart_after_none, { count: after })) }));
    }
    if (n >= 2 || inCart > 0) parts.push(el('p', { class: 'sg-summary__note', text: s.cart_note }));
    this.summary.innerHTML = '';
    parts.forEach(function (node) { this.summary.appendChild(node); }, this);
  };

  Offers.prototype.applyButtonState = function () {
    if (!this.button) return;
    if (this.qty < 2) {
      if (this._overridden) {
        // Hand control back to the theme: let it recompute the button for the current selection.
        this._overridden = false;
        var section = this.c.closest('[data-section-type="product"]') || document;
        var checked = section.querySelector('[data-variant-input]:checked') || section.querySelector('select[data-variant-input]');
        if (checked) {
          checked.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          var v = this.variant(this.mainVariantId());
          var available = !!(v && v.available);
          this.button.disabled = !available;
          this.button.classList.toggle('disabled', !available);
          if (this.buttonText) this.buttonText.textContent = available ? (this.buttonText.getAttribute('data-default-text') || this.s.add_to_cart) : this.s.sold_out;
        }
      }
      return;
    }
    this._overridden = true;
    var pending = this.rows.filter(function (r) { return !r.added; });
    var allValid = pending.length > 0 && pending.every(function (r) { return r.valid; });
    this.button.disabled = this.busy || !allValid;
    this.button.classList.toggle('disabled', this.button.disabled);
    if (this.buttonText) this.buttonText.textContent = this.busy ? this.s.adding : fmt(this.s.add_n, { count: pending.length || this.qty });
    this.button.setAttribute('aria-busy', this.busy ? 'true' : 'false');
  };

  Offers.prototype.showError = function (msg) {
    this.errorNode.textContent = msg;
    this.errorNode.hidden = false;
  };
  Offers.prototype.hideError = function () { this.errorNode.hidden = true; this.errorNode.textContent = ''; };

  Offers.prototype.addSelection = function () {
    var self = this;
    if (this.busy) return; // double-click protection
    var pending = this.rows.filter(function (r) { return !r.added; });
    if (!pending.length || !pending.every(function (r) { return r.valid; })) {
      this.showError(this.s.unavailable_combo);
      return;
    }
    this.busy = true;
    this.hideError();
    this.applyButtonState();
    var units = pending.map(function (r) {
      var v = self.variant(r.variantId);
      return { key: r.key, variantId: r.variantId, label: self.product.title + (v && v.title !== 'Default Title' ? ' (' + v.title + ')' : '') };
    });
    addUnits(units).then(function (result) {
      self.rows.forEach(function (r) { if (result.addedKeys.indexOf(r.key) !== -1) r.added = true; });
      if (result.addedKeys.length) refreshCartUI(result.ok);
      if (result.ok) {
        // Fresh start for the next purchase, same offer selected.
        self.rows.forEach(function (r) { r.added = false; });
      } else if (result.addedKeys.length) {
        self.showError(fmt(self.s.added_partial, {
          added: result.addedKeys.length,
          failed: result.failedUnits.map(function (u) { return u.label; }).join(', ')
        }) + (result.message ? ' (' + result.message + ')' : ''));
      } else {
        self.showError(result.message ? result.message : self.s.error_generic);
      }
    }).catch(function () {
      self.showError(self.s.error_generic);
    }).then(function () {
      self.busy = false;
      self.renderRows();
      self.update();
    });
  };

  /* ---------------------------------------------------------------- bundle */
  function Bundle(offers) {
    this.o = offers;
    this.s = offers.s;
    this.c = offers.c;
    this.dlg = this.c.querySelector('[data-sg-bundle]');
    this.openBtn = this.c.querySelector('[data-sg-bundle-open]');
    this.search = this.dlg.querySelector('[data-sg-search]');
    this.results = this.dlg.querySelector('[data-sg-results]');
    this.status = this.dlg.querySelector('[data-sg-status]');
    this.moreBtn = this.dlg.querySelector('[data-sg-more-results]');
    this.browse = this.dlg.querySelector('[data-sg-browse]');
    this.pick = this.dlg.querySelector('[data-sg-pick]');
    this.selNode = this.dlg.querySelector('[data-sg-selection]');
    this.totals = this.dlg.querySelector('[data-sg-bundle-totals]');
    this.addBtn = this.dlg.querySelector('[data-sg-bundle-add]');
    this.errorNode = this.dlg.querySelector('[data-sg-bundle-error]');
    this.selection = []; // [{ key, product, variant }]
    this.source = { type: 'collection', handle: 'all', q: '' };
    this.page = 1;
    this.loaded = false;
    this.busy = false;
    this.productCache = {};
    this.bind();
  }

  Bundle.prototype.bind = function () {
    var self = this;
    this.openBtn.addEventListener('click', function () { self.open(); });
    this.dlg.querySelector('[data-sg-bundle-close]').addEventListener('click', function () { self.dlg.close(); });
    var t = null;
    this.search.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var q = self.search.value.trim();
        self.setChip(q ? null : 'all');
        self.source = q ? { type: 'search', q: q } : { type: 'collection', handle: 'all' };
        self.load(true);
      }, 350);
    });
    this.search.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    this.dlg.querySelectorAll('[data-sg-collection]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        self.search.value = '';
        self.setChip(chip.getAttribute('data-sg-collection'));
        self.source = { type: 'collection', handle: chip.getAttribute('data-sg-collection') };
        self.load(true);
      });
    });
    this.moreBtn.addEventListener('click', function () { self.page += 1; self.load(false); });
    this.addBtn.addEventListener('click', function () { self.addToCart(); });
    Cart.onChange(function () { if (self.dlg.open) self.renderSelection(); });
  };

  Bundle.prototype.setChip = function (handle) {
    this.dlg.querySelectorAll('[data-sg-collection]').forEach(function (chip) {
      var on = chip.getAttribute('data-sg-collection') === handle;
      chip.classList.toggle('is-active', on);
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };

  Bundle.prototype.open = function () {
    var self = this;
    openDialog(this.dlg, this.openBtn);
    if (!this.loaded) {
      this.loaded = true;
      this.load(true);
      // Start from the shopper's current choice on this page, unless that exact item is already in the cart.
      Cart.fetch().catch(function () { return null; }).then(function () {
        var mainId = self.o.mainVariantId();
        var v = self.o.variant(mainId);
        var inCart = Cart.qtyByVariant()[mainId] > 0;
        if (v && v.available && !inCart && !self.selection.length) {
          self.selection.push({ key: 'k' + Date.now(), product: self.o.product, variant: v });
        }
        self.renderSelection();
      });
    } else {
      this.renderSelection();
    }
  };

  Bundle.prototype.url = function () {
    if (this.source.type === 'search') {
      return root + 'search?q=' + encodeURIComponent(this.source.q) + '&type=product&options%5Bprefix%5D=last&section_id=sg-bundle-items&page=' + this.page;
    }
    return root + 'collections/' + encodeURIComponent(this.source.handle) + '?section_id=sg-bundle-items&page=' + this.page;
  };

  Bundle.prototype.load = function (reset) {
    var self = this;
    if (reset) { this.page = 1; this.results.innerHTML = ''; }
    var token = (this.loadToken = Math.random());
    this.status.textContent = this.s.b_loading;
    this.moreBtn.hidden = true;
    fetch(this.url(), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (token !== self.loadToken) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var data = readJSON(doc, '[data-sg-items]') || { items: [], hasNext: false };
        data.items.forEach(function (item) { self.results.appendChild(self.renderResult(item)); });
        self.status.textContent = self.results.children.length ? '' : self.s.b_no_results;
        self.moreBtn.hidden = !data.hasNext;
      })
      .catch(function () {
        if (token !== self.loadToken) return;
        self.status.textContent = self.s.error_generic;
      });
  };

  Bundle.prototype.renderResult = function (item) {
    var self = this;
    var btn = el('button', { type: 'button', class: 'sg-result', 'aria-label': self.s.b_choose + ' : ' + item.title }, [
      item.image ? el('img', { src: item.image, alt: '', loading: 'lazy', width: 150, height: 150 }) : el('span', { class: 'sg-result__noimg' }),
      el('span', { class: 'sg-result__title', text: item.title }),
      el('span', { class: 'sg-result__price', text: (item.priceVaries ? self.s.b_price_from + ' ' : '') + money(item.price, self.o.moneyFormat) }),
      el('span', { class: 'sg-result__cta', 'aria-hidden': 'true', text: self.s.b_choose })
    ]);
    btn.addEventListener('click', function () { self.openProduct(item.handle, btn, null); });
    return el('li', null, [btn]);
  };

  Bundle.prototype.fetchProduct = function (handle) {
    var self = this;
    if (this.productCache[handle]) return Promise.resolve(this.productCache[handle]);
    return fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=sg-bundle-product', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var product = readJSON(doc, '[data-sg-bundle-product]');
        if (!product) throw new Error('product');
        var guide = doc.querySelector('[data-sg-bundle-guide] dialog');
        if (guide && !document.getElementById(guide.id)) document.body.appendChild(document.importNode(guide, true));
        self.productCache[handle] = product;
        return product;
      });
  };

  /* replaceKey: when editing an existing selection row */
  Bundle.prototype.openProduct = function (handle, opener, replaceKey, variantId) {
    var self = this;
    this.pickOpener = opener;
    this.status.textContent = this.s.b_loading;
    this.fetchProduct(handle).then(function (product) {
      self.status.textContent = '';
      self.renderPick(product, replaceKey, variantId);
    }).catch(function () { self.status.textContent = self.s.error_generic; });
  };

  Bundle.prototype.renderPick = function (product, replaceKey, variantId) {
    var self = this;
    var pick = this.pick;
    pick.innerHTML = '';
    var current = null;
    var priceNode = el('p', { class: 'sg-pick__price' });
    var imgNode = el('img', { class: 'sg-pick__img', alt: '', width: 120, height: 120 });
    var addBtn = el('button', { type: 'button', class: 'btn btn--full sg-pick__add', text: replaceKey ? self.s.b_replace_in_selection : self.s.b_add_to_selection });
    var picker = new VariantPicker(product, {
      variantId: variantId,
      strings: self.s,
      idPrefix: 'sg-pick-' + product.id,
      onChange: function (v) { current = v; refresh(); }
    });
    function refresh() {
      current = picker.current();
      priceNode.textContent = current ? money(current.price, self.o.moneyFormat) : '';
      var src = (current && current.image) || product.image;
      if (src) imgNode.src = src;
      addBtn.disabled = !(current && current.available);
    }
    var back = el('button', { type: 'button', class: 'sg-pick__back', text: '← ' + self.s.b_back });
    back.addEventListener('click', function () { self.closePick(); });
    var heading = el('h3', { class: 'sg-pick__title', tabindex: '-1', text: product.title });
    var guideBtn = null;
    if (product.sizeGuide) {
      guideBtn = el('button', { type: 'button', class: 'sg-trigger', 'data-sg-open': product.sizeGuide, 'aria-haspopup': 'dialog' }, [self.s.b_size_guide]);
    }
    addBtn.addEventListener('click', function () {
      if (!current || !current.available) return;
      var entry = { key: replaceKey || 'k' + Date.now() + Math.random().toString(36).slice(2, 6), product: product, variant: current };
      if (replaceKey) {
        self.selection = self.selection.map(function (x) { return x.key === replaceKey ? entry : x; });
      } else {
        self.selection.push(entry);
      }
      self.renderSelection();
      self.closePick();
    });
    pick.appendChild(back);
    pick.appendChild(el('div', { class: 'sg-pick__head' }, [imgNode, el('div', null, [heading, priceNode, guideBtn])]));
    pick.appendChild(picker.node);
    pick.appendChild(addBtn);
    refresh();
    this.browse.hidden = true;
    pick.hidden = false;
    heading.focus();
  };

  Bundle.prototype.closePick = function () {
    this.pick.hidden = true;
    this.pick.innerHTML = '';
    this.browse.hidden = false;
    if (this.pickOpener && document.contains(this.pickOpener)) this.pickOpener.focus();
  };

  Bundle.prototype.renderSelection = function () {
    var self = this;
    var s = this.s;
    var fmtM = function (c) { return money(c, self.o.moneyFormat); };
    this.selNode.innerHTML = '';
    // Group identical variants for display; each unit is still a separate entry.
    var groups = [];
    this.selection.forEach(function (entry) {
      var g = groups.filter(function (x) { return x.variant.id === entry.variant.id; })[0];
      if (g) { g.entries.push(entry); } else { groups.push({ product: entry.product, variant: entry.variant, entries: [entry] }); }
    });
    if (!groups.length) {
      this.selNode.appendChild(el('li', { class: 'sg-selection__empty', text: s.b_selection_empty }));
    }
    groups.forEach(function (g) {
      var qty = g.entries.length;
      var img = g.variant.image || g.product.image;
      var remove = el('button', { type: 'button', class: 'sg-link', text: s.b_remove,
        'aria-label': s.b_remove + ' : ' + g.product.title + (g.variant.title !== 'Default Title' ? ' (' + g.variant.title + ')' : '') });
      remove.addEventListener('click', function () {
        var last = g.entries[g.entries.length - 1];
        self.selection = self.selection.filter(function (x) { return x.key !== last.key; });
        self.renderSelection();
        self.addBtn.focus();
      });
      var replace = el('button', { type: 'button', class: 'sg-link', text: s.b_replace,
        'aria-label': s.b_replace + ' : ' + g.product.title });
      replace.addEventListener('click', function () {
        self.openProduct(g.product.handle, self.addBtn, g.entries[g.entries.length - 1].key, g.variant.id);
      });
      self.selNode.appendChild(el('li', { class: 'sg-selection__item' }, [
        img ? el('img', { src: img, alt: '', width: 56, height: 56, loading: 'lazy' }) : el('span', { class: 'sg-result__noimg' }),
        el('div', { class: 'sg-selection__meta' }, [
          el('span', { class: 'sg-selection__name', text: g.product.title }),
          g.variant.title !== 'Default Title' ? el('span', { class: 'sg-selection__variant', text: g.variant.title }) : null,
          el('span', { class: 'sg-selection__qty', text: '× ' + qty + ' · ' + fmtM(g.variant.price * qty) })
        ]),
        el('div', { class: 'sg-selection__actions' }, [replace, remove])
      ]));
    });

    var n = this.selection.length;
    var inCart = Cart.data ? Cart.count() : 0;
    var totalCount = n + inCart;
    var pct = this.o.pctFor(totalCount);
    var subtotal = this.selection.reduce(function (sum, e) { return sum + e.variant.price; }, 0);
    var saving = discountFor(subtotal, pct);
    this.totals.innerHTML = '';
    if (n) {
      this.totals.appendChild(el('div', { class: 'sg-totals__row' }, [el('span', { text: s.b_subtotal }), el('span', { text: fmtM(subtotal) })]));
      if (pct > 0) {
        this.totals.appendChild(el('div', { class: 'sg-totals__row sg-totals__row--saving' }, [el('span', { text: fmt(s.b_estimated_saving, { percent: pct }) }), el('span', { text: '−' + fmtM(saving) })]));
      }
      this.totals.appendChild(el('div', { class: 'sg-totals__row sg-totals__row--total' }, [el('span', { text: s.b_estimated_total }), el('strong', { text: fmtM(subtotal - saving) })]));
    }
    if (inCart > 0) {
      this.totals.appendChild(el('p', { class: 'sg-totals__note', text: fmt(s.b_existing_cart, { count: inCart }) }));
      if (pct > 0) this.totals.appendChild(el('p', { class: 'sg-totals__note', text: fmt(s.b_tier_reached, { count: totalCount, percent: pct }) }));
    }
    var next = this.o.nextTier(totalCount);
    if (next && next.pct > 0) {
      this.totals.appendChild(el('p', { class: 'sg-totals__next', text: fmt(s.b_tier_next, { missing: next.at - totalCount, percent: next.pct }) }));
    }
    if (n || inCart) this.totals.appendChild(el('p', { class: 'sg-totals__note', text: s.cart_note }));
    this.addBtn.textContent = fmt(s.b_add_bundle, { count: n });
    this.addBtn.disabled = this.busy || n === 0;
    this.addBtn.setAttribute('aria-busy', this.busy ? 'true' : 'false');
  };

  Bundle.prototype.addToCart = function () {
    var self = this;
    if (this.busy || !this.selection.length) return;
    this.busy = true;
    this.errorNode.hidden = true;
    this.addBtn.disabled = true;
    this.addBtn.textContent = this.s.adding;
    var units = this.selection.map(function (e) {
      return { key: e.key, variantId: e.variant.id, label: e.product.title + (e.variant.title !== 'Default Title' ? ' (' + e.variant.title + ')' : '') };
    });
    addUnits(units).then(function (result) {
      // Anything that made it into the cart leaves the pending selection, so a retry never duplicates it.
      self.selection = self.selection.filter(function (e) { return result.addedKeys.indexOf(e.key) === -1; });
      if (result.ok) {
        self.busy = false;
        self.renderSelection();
        self.dlg.close();
        refreshCartUI(true);
        return;
      }
      if (result.addedKeys.length) refreshCartUI(false);
      self.errorNode.textContent = result.addedKeys.length
        ? fmt(self.s.added_partial, { added: result.addedKeys.length, failed: result.failedUnits.map(function (u) { return u.label; }).join(', ') }) + (result.message ? ' (' + result.message + ')' : '')
        : (result.message || self.s.error_generic);
      self.errorNode.hidden = false;
    }).catch(function () {
      self.errorNode.textContent = self.s.error_generic;
      self.errorNode.hidden = false;
    }).then(function () {
      self.busy = false;
      self.renderSelection();
    });
  };

  /* ---------------------------------------------------------------- boot */
  function boot(scope) {
    (scope || document).querySelectorAll('[data-sg-offers]').forEach(function (node) {
      if (node._sgOffers) return;
      node._sgOffers = new Offers(node);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  window.SGFeatures.Cart = Cart;
  window.SGFeatures.VariantPicker = VariantPicker; // exposed for testing
})();
